/* Martha's World — AURA: glitter, elemental FX, liquid-glass tilt, smooth add-to-bag */
(function () {
  'use strict';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  function money(cents) {
    var s = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: CUR });
    return s.replace(/\.00$/, '');
  }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(arr) { return arr[(Math.random() * arr.length) | 0]; }

  /* ---------- canvas engine: runs only while visible ---------- */
  function Stage(canvas, setup, draw) {
    var ctx = canvas.getContext('2d');
    var st = { c: canvas, ctx: ctx, w: 0, h: 0, t: 0, boost: 0, target: 0, running: false, raf: 0, data: null };
    function size() {
      var r = canvas.getBoundingClientRect();
      st.w = Math.max(1, r.width); st.h = Math.max(1, r.height);
      canvas.width = Math.round(st.w * DPR); canvas.height = Math.round(st.h * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      st.data = setup(st);
    }
    function loop(ts) {
      st.t = ts / 1000;
      st.boost += (st.target - st.boost) * 0.06;
      ctx.clearRect(0, 0, st.w, st.h);
      draw(st);
      if (st.running) st.raf = requestAnimationFrame(loop);
    }
    st.start = function () { if (st.running || REDUCE) return; st.running = true; st.raf = requestAnimationFrame(loop); };
    st.stop = function () { st.running = false; cancelAnimationFrame(st.raf); };
    size();
    if ('ResizeObserver' in window) new ResizeObserver(function () { size(); if (REDUCE) draw(st); }).observe(canvas);
    if (REDUCE) { st.t = 1; draw(st); return st; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? st.start() : st.stop(); }); }, { rootMargin: '80px' }).observe(canvas);
    } else st.start();
    return st;
  }

  /* ---------- glitter sparkles ---------- */
  /* 8-bit sparkle: a crisp pixel plus with diagonal glints */
  function star(ctx, x, y, r, a, col) {
    var p = Math.max(1.5, Math.round(r * 0.5));
    x = Math.round(x); y = Math.round(y);
    ctx.globalAlpha = a; ctx.fillStyle = col;
    ctx.fillRect(x - p / 2, y - p * 2.5, p, p * 5);
    ctx.fillRect(x - p * 2.5, y - p / 2, p * 5, p);
    if (r > 2.6) {
      ctx.globalAlpha = a * 0.55;
      ctx.fillRect(x - p * 1.5, y - p * 1.5, p, p); ctx.fillRect(x + p * 0.5, y - p * 1.5, p, p);
      ctx.fillRect(x - p * 1.5, y + p * 0.5, p, p); ctx.fillRect(x + p * 0.5, y + p * 0.5, p, p);
    }
  }
  function glitter(canvas) {
    var dens = parseFloat(canvas.dataset.density || '1');
    var cols = ['#ffffff', '#ff8fc2', '#b99bff', '#7fd0ff', '#ffd27a'];
    if (canvas.closest('.mw-statement')) cols = ['#ffffff', '#ff8fd0', '#7ae3ff', '#ffe36e', '#c9b8ff'];
    else if (canvas.closest('.mw-hero')) cols = ['#ffffff', '#ffe36e', '#ffb8a3', '#ffd1e6', '#bfe3ff'];
    else if (canvas.closest('.mw-tile--gold')) cols = ['#ffffff', '#fff4b0', '#ffb84a', '#ff8f73'];
    Stage(canvas, function (st) {
      var n = Math.round(st.w * st.h / 7000 * dens), p = [];
      for (var i = 0; i < n; i++) p.push({ x: rand(0, st.w), y: rand(0, st.h), r: rand(1.4, 4.2), sp: rand(0.6, 2.2), ph: rand(0, 6.28), c: pick(cols), vy: rand(-6, -2) });
      return p;
    }, function (st) {
      var ctx = st.ctx; ctx.globalCompositeOperation = 'lighter';
      st.data.forEach(function (s) {
        var tw = Math.pow((Math.sin(st.t * s.sp + s.ph) + 1) / 2, 3);
        var y = (s.y + st.t * s.vy) % st.h; if (y < 0) y += st.h;
        star(ctx, s.x, y, s.r * (0.6 + tw), tw * 0.95, s.c);
      });
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    });
  }

  /* ---------- elemental FX ---------- */
  var FX = {
    fire: {
      setup: function (st) { var p = []; for (var i = 0; i < 70; i++) p.push(this.spawn(st, true)); return p; },
      spawn: function (st, any) { return { x: rand(0, st.w), y: any ? rand(0, st.h) : st.h + rand(0, 20), vy: rand(0.5, 1.6), r: rand(1, 3.6), life: rand(0.5, 1), ph: rand(0, 6.28), c: pick(['#fff1b8', '#ffc76b', '#ff8a4c', '#ff5f7e']) }; },
      draw: function (st) {
        var ctx = st.ctx, self = this; ctx.globalCompositeOperation = 'lighter';
        var g = ctx.createLinearGradient(0, st.h, 0, st.h * 0.55);
        g.addColorStop(0, 'rgba(255,160,80,' + (0.35 + st.boost * 0.25) + ')'); g.addColorStop(1, 'rgba(255,120,120,0)');
        ctx.fillStyle = g; ctx.fillRect(0, st.h * 0.55, st.w, st.h * 0.45);
        st.data.forEach(function (e, i) {
          e.y -= e.vy * (1 + st.boost * 1.4); e.x += Math.sin(st.t * 2 + e.ph) * 0.4;
          var a = Math.max(0, e.y / st.h) * e.life;
          ctx.globalAlpha = a; ctx.fillStyle = e.c; ctx.shadowColor = e.c; ctx.shadowBlur = 8;
          ctx.beginPath(); ctx.arc(e.x, e.y, e.r * (0.8 + Math.sin(st.t * 9 + e.ph) * 0.2), 0, 6.283); ctx.fill();
          if (e.y < -10) st.data[i] = self.spawn(st, false);
        });
        ctx.shadowBlur = 0; ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
      }
    },
    water: {
      setup: function (st) { var p = []; for (var i = 0; i < 34; i++) p.push(this.spawn(st, true)); return p; },
      spawn: function (st, any) { return { x: rand(0, st.w), y: any ? rand(0, st.h) : st.h + rand(5, 40), vy: rand(0.3, 0.9), r: rand(2.5, 9), ph: rand(0, 6.28) }; },
      draw: function (st) {
        var ctx = st.ctx, self = this;
        for (var k = 0; k < 2; k++) {
          ctx.beginPath(); ctx.moveTo(0, st.h);
          for (var x = 0; x <= st.w; x += 8) ctx.lineTo(x, st.h * (0.86 + k * 0.05) + Math.sin(x / 38 + st.t * (1.2 + k * 0.5) + k) * (5 + st.boost * 4));
          ctx.lineTo(st.w, st.h); ctx.closePath();
          ctx.fillStyle = k ? 'rgba(255,255,255,.22)' : 'rgba(120,170,255,.25)'; ctx.fill();
        }
        st.data.forEach(function (b, i) {
          b.y -= b.vy * (1 + st.boost * 1.6); b.x += Math.sin(st.t * 1.5 + b.ph) * 0.35;
          ctx.globalAlpha = 0.85; ctx.strokeStyle = 'rgba(255,255,255,.85)'; ctx.lineWidth = 1.2;
          ctx.beginPath(); ctx.arc(b.x, b.y, b.r, 0, 6.283); ctx.stroke();
          ctx.fillStyle = 'rgba(255,255,255,.18)'; ctx.fill();
          ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.beginPath(); ctx.arc(b.x - b.r * 0.35, b.y - b.r * 0.35, b.r * 0.22, 0, 6.283); ctx.fill();
          if (b.y < -12) st.data[i] = self.spawn(st, false);
        });
        ctx.globalAlpha = 1;
      }
    },
    air: {
      setup: function (st) {
        var s = [], h = [];
        for (var i = 0; i < 9; i++) s.push({ y: rand(0.08, 0.8), off: rand(0, 1), sp: rand(0.05, 0.12), amp: rand(6, 16), len: rand(0.25, 0.5) });
        for (var j = 0; j < 12; j++) h.push({ x: rand(0, st.w), y: rand(0, st.h), r: rand(4, 8), vy: rand(0.2, 0.5), ph: rand(0, 6.28), c: pick(['#ff7ab6', '#ffffff', '#ffb3d6', '#b9a6ff']) });
        return { s: s, h: h };
      },
      heart: function (ctx, x, y, r) { ctx.beginPath(); ctx.moveTo(x, y + r * 0.35); ctx.bezierCurveTo(x - r * 1.2, y - r * 0.5, x - r * 0.4, y - r * 1.3, x, y - r * 0.45); ctx.bezierCurveTo(x + r * 0.4, y - r * 1.3, x + r * 1.2, y - r * 0.5, x, y + r * 0.35); ctx.fill(); },
      draw: function (st) {
        var ctx = st.ctx, self = this, sp = 1 + st.boost * 1.5;
        ctx.lineCap = 'round';
        st.data.s.forEach(function (w) {
          var head = ((st.t * w.sp * sp + w.off) % 1.4) - 0.2;
          var g = ctx.createLinearGradient((head - w.len) * st.w, 0, head * st.w, 0);
          g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(255,255,255,.75)');
          ctx.strokeStyle = g; ctx.lineWidth = 1.6; ctx.beginPath();
          for (var x = (head - w.len) * st.w; x <= head * st.w; x += 6) {
            var yy = w.y * st.h + Math.sin(x / 40 + st.t) * w.amp;
            x === (head - w.len) * st.w ? ctx.moveTo(x, yy) : ctx.lineTo(x, yy);
          }
          ctx.stroke();
        });
        st.data.h.forEach(function (h) {
          h.y -= h.vy * sp; h.x += Math.sin(st.t + h.ph) * 0.5 + 0.25 * sp;
          if (h.y < -10) { h.y = st.h + 10; h.x = rand(0, st.w); }
          if (h.x > st.w + 10) h.x = -10;
          ctx.globalAlpha = 0.75; ctx.fillStyle = h.c; self.heart(ctx, h.x, h.y, h.r);
        });
        ctx.globalAlpha = 1;
      }
    },
    earth: {
      setup: function (st) { var p = []; for (var i = 0; i < 26; i++) p.push({ x: rand(0, st.w), y: rand(0, st.h), s: rand(4, 11), rot: rand(0, 6.28), vr: rand(-0.01, 0.01), vy: rand(0.1, 0.35), ph: rand(0, 6.28), c: pick(['#ffffff', '#e5d6ff', '#b9f0dc', '#d6c2ff']) }); return p; },
      draw: function (st) {
        var ctx = st.ctx;
        st.data.forEach(function (c) {
          c.y -= c.vy * (1 + st.boost); c.rot += c.vr * (1 + st.boost * 2);
          if (c.y < -14) { c.y = st.h + 14; c.x = rand(0, st.w); }
          var tw = 0.45 + 0.55 * Math.pow((Math.sin(st.t * 1.6 + c.ph) + 1) / 2, 2);
          ctx.save(); ctx.translate(c.x, c.y); ctx.rotate(c.rot);
          ctx.globalAlpha = 0.55 * tw; ctx.fillStyle = c.c;
          ctx.beginPath(); ctx.moveTo(0, -c.s * 1.4); ctx.lineTo(c.s * 0.6, 0); ctx.lineTo(0, c.s * 1.4); ctx.lineTo(-c.s * 0.6, 0); ctx.closePath(); ctx.fill();
          ctx.globalAlpha = 0.9 * tw; ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 0.8; ctx.stroke();
          ctx.restore();
          if (tw > 0.92) star(ctx, c.x + c.s, c.y - c.s, 3.5, (tw - 0.92) * 10, '#ffffff');
        });
        ctx.globalAlpha = 1;
      }
    },
    storm: {
      setup: function (st) { var s = []; for (var i = 0; i < 60; i++) s.push({ x: rand(0, st.w), y: rand(0, st.h * 0.85), r: rand(0.6, 1.8), ph: rand(0, 6.28), sp: rand(0.8, 2.4) }); return { s: s, bolt: null, next: 1.5, flash: 0 }; },
      bolt: function (st) { var pts = [], x = rand(st.w * 0.2, st.w * 0.8), y = 0; pts.push([x, y]); while (y < st.h * rand(0.45, 0.75)) { y += rand(14, 30); x += rand(-22, 22); pts.push([x, y]); } return pts; },
      draw: function (st) {
        var ctx = st.ctx, d = st.data;
        d.s.forEach(function (s) { var a = 0.3 + 0.7 * Math.pow((Math.sin(st.t * s.sp + s.ph) + 1) / 2, 2); ctx.globalAlpha = a; ctx.fillStyle = '#ffffff'; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.283); ctx.fill(); });
        if (st.t > d.next) { d.bolt = this.bolt(st); d.flash = 1; d.next = st.t + rand(2.2, 4.5) / (1 + st.boost * 2); }
        if (d.flash > 0) {
          ctx.globalAlpha = d.flash * 0.22; ctx.fillStyle = '#c9ff9a'; ctx.fillRect(0, 0, st.w, st.h);
          ctx.globalAlpha = d.flash; ctx.strokeStyle = '#eaffd6'; ctx.shadowColor = '#a6ff5a'; ctx.shadowBlur = 16; ctx.lineWidth = 2.2;
          ctx.beginPath(); d.bolt.forEach(function (p, i) { i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]); }); ctx.stroke();
          ctx.shadowBlur = 0; d.flash -= 0.045;
        }
        ctx.globalAlpha = 1;
      }
    },
    space: {
      setup: function (st) {
        var s = [], n = [];
        for (var i = 0; i < 90; i++) s.push({ x: rand(0, st.w), y: rand(0, st.h), z: pick([1, 1, 1, 2, 2, 3]), ph: rand(0, 6.28), sp: rand(0.6, 2.2), c: pick(['#ffffff', '#ffe7a3', '#bfe9ff', '#ffc2e6']) });
        n.push({ x: 0.3, y: 0.25, r: 0.55, c: '224,68,168' }, { x: 0.78, y: 0.5, r: 0.5, c: '51,193,214' }, { x: 0.45, y: 0.75, r: 0.6, c: '107,59,214' });
        return { s: s, n: n, shoot: null, next: 1.2, ang: 0 };
      },
      draw: function (st) {
        var ctx = st.ctx, d = st.data, sp = 1 + st.boost * 1.5;
        ctx.globalCompositeOperation = 'lighter';
        d.n.forEach(function (b, i) {
          var cx = (b.x + Math.sin(st.t * 0.12 + i) * 0.05) * st.w, cy = (b.y + Math.cos(st.t * 0.1 + i) * 0.04) * st.h, r = b.r * Math.max(st.w, st.h);
          var g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
          g.addColorStop(0, 'rgba(' + b.c + ',' + (0.32 + st.boost * 0.12) + ')'); g.addColorStop(1, 'rgba(' + b.c + ',0)');
          ctx.fillStyle = g; ctx.fillRect(0, 0, st.w, st.h);
        });
        ctx.globalCompositeOperation = 'source-over';
        d.s.forEach(function (s) {
          var a = 0.25 + 0.75 * Math.pow((Math.sin(st.t * s.sp * sp + s.ph) + 1) / 2, 2);
          if (s.z === 3) star(ctx, s.x, s.y, 3.2, a, s.c);
          else { ctx.globalAlpha = a; ctx.fillStyle = s.c; ctx.fillRect(Math.round(s.x), Math.round(s.y), s.z, s.z); }
        });
        d.ang += 0.004 * sp;
        var px = st.w * 0.74 + Math.cos(d.ang) * st.w * 0.08, py = st.h * 0.16 + Math.sin(d.ang) * st.h * 0.025;
        ctx.globalAlpha = 0.95;
        var pg = ctx.createRadialGradient(px - 4, py - 4, 1, px, py, 11);
        pg.addColorStop(0, '#ffd1b8'); pg.addColorStop(1, '#ff6a4d');
        ctx.fillStyle = pg; ctx.beginPath(); ctx.arc(px, py, 10, 0, 6.283); ctx.fill();
        ctx.strokeStyle = 'rgba(255,228,110,.9)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.ellipse(px, py, 18, 5, -0.35, 0, 6.283); ctx.stroke();
        if (st.t > d.next && !d.shoot) { d.shoot = { x: rand(st.w * 0.05, st.w * 0.6), y: rand(0, st.h * 0.35), l: 1 }; d.next = st.t + rand(2, 4.5) / sp; }
        if (d.shoot) {
          var o = d.shoot; o.x += 6 * sp; o.y += 3 * sp; o.l -= 0.03;
          var tg = ctx.createLinearGradient(o.x - 60, o.y - 30, o.x, o.y);
          tg.addColorStop(0, 'rgba(255,255,255,0)'); tg.addColorStop(1, 'rgba(255,255,255,' + o.l + ')');
          ctx.globalAlpha = 1; ctx.strokeStyle = tg; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(o.x - 60, o.y - 30); ctx.lineTo(o.x, o.y); ctx.stroke();
          star(ctx, o.x, o.y, 3, o.l, '#ffffff');
          if (o.l <= 0) d.shoot = null;
        }
        ctx.globalAlpha = 1;
      }
    },
    gold: { setup: function () { return null; }, draw: function () {} },
    aura: { setup: function () { return null; }, draw: function () {} }
  };
  function fx(canvas) {
    var kind = FX[canvas.dataset.el];
    if (!kind) return;
    if (canvas.dataset.el === 'gold' || canvas.dataset.el === 'aura') { canvas.classList.remove('mw-fx'); canvas.classList.add('mw-glitter'); canvas.dataset.density = '0.5'; glitter(canvas); return; }
    var st = Stage(canvas, function (s) { return kind.setup(s); }, function (s) { kind.draw(s); });
    var host = canvas.closest('.mw-gcard, .mw-pdp__stage');
    if (host) {
      host.addEventListener('pointerenter', function () { st.target = 1; });
      host.addEventListener('pointerleave', function () { st.target = 0; });
      host.addEventListener('focusin', function () { st.target = 1; });
      host.addEventListener('focusout', function () { st.target = 0; });
    }
  }

  /* ---------- liquid-glass tilt ---------- */
  function tilt(el) {
    if (!FINE || REDUCE) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.transitionDelay = '0s';
      el.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
      el.style.setProperty('--rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
      el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
      el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
  }

  /* ---------- sparkle burst (on add) ---------- */
  function burst(x, y) {
    if (REDUCE) return;
    var c = document.createElement('canvas'); c.className = 'mw-burst'; document.body.appendChild(c);
    var w = innerWidth, h = innerHeight; c.width = w * DPR; c.height = h * DPR; c.style.width = w + 'px'; c.style.height = h + 'px';
    var ctx = c.getContext('2d'); ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    var p = [], cols = ['#ff7ab6', '#b48bff', '#62c6ff', '#ffd27a', '#ffffff'];
    for (var i = 0; i < 36; i++) { var a = rand(0, 6.28), s = rand(2, 7); p.push({ x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s - 2, r: rand(2, 5), c: pick(cols), life: 1 }); }
    (function step() {
      ctx.clearRect(0, 0, w, h); var alive = false;
      p.forEach(function (q) { q.x += q.vx; q.y += q.vy; q.vy += 0.18; q.vx *= 0.98; q.life -= 0.022; if (q.life > 0) { alive = true; star(ctx, q.x, q.y, q.r * 1.6, q.life, q.c); } });
      ctx.globalAlpha = 1;
      if (alive) requestAnimationFrame(step); else c.remove();
    })();
  }

  /* ---------- smooth add-to-bag ---------- */
  var bag, bagTimer, lastFocus;
  function freeShipCents() { var n = document.querySelector('[data-free-ship]'); return n ? parseFloat(n.dataset.freeShip) * 100 : 5000; }
  function ensureBag() {
    if (bag) return bag;
    bag = document.createElement('div');
    bag.className = 'mw-minibag'; bag.setAttribute('role', 'dialog'); bag.setAttribute('aria-modal', 'false'); bag.setAttribute('aria-label', 'Bag'); bag.tabIndex = -1;
    document.body.appendChild(bag);
    bag.addEventListener('mouseenter', function () { clearTimeout(bagTimer); });
    bag.addEventListener('mouseleave', function () { arm(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBag(); });
    return bag;
  }
  function arm() { clearTimeout(bagTimer); bagTimer = setTimeout(closeBag, 7000); }
  function closeBag() { if (!bag) return; bag.classList.remove('is-open'); if (lastFocus && document.activeElement && bag.contains(document.activeElement)) lastFocus.focus(); }
  function openBag(html) {
    ensureBag(); bag.innerHTML = html; bag.classList.add('is-open'); arm();
    var x = bag.querySelector('.mw-minibag__close'); if (x) x.addEventListener('click', closeBag);
    var go = bag.querySelector('.mw-minibag__checkout'); if (go) go.focus({ preventScroll: true });
  }
  function setCount(n) {
    var link = document.querySelector('.mw-nav__icons a[href$="/cart"]');
    if (!link) return;
    var c = link.querySelector('.mw-nav__count');
    if (!c && n > 0) { c = document.createElement('span'); c.className = 'mw-nav__count'; link.appendChild(c); }
    if (!c) return;
    c.textContent = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    link.setAttribute('aria-label', 'Bag, ' + n + ' items');
    if (n === 0) c.remove();
  }
  function shipLine(total) {
    var need = freeShipCents() - total, pct = Math.min(100, Math.round(total / freeShipCents() * 100));
    var msg = need > 0 ? 'You’re <strong>' + money(need) + '</strong> away from free shipping.' : '<strong>Free shipping unlocked.</strong>';
    return '<p class="mw-minibag__ship">' + msg + '</p><div class="mw-minibag__bar"><span style="width:' + pct + '%"></span></div>';
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  var CHECK = '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="url(#mwg)"/><defs><linearGradient id="mwg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ff7ab6"/><stop offset="1" stop-color="#8a6bff"/></linearGradient></defs><path d="M5.5 10.4l3 3 6-6.4" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function onSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1 || form.dataset.native === '1') return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    lastFocus = document.activeElement;
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          openBag('<div class="mw-minibag__head"><p class="mw-minibag__title">Couldn’t add that</p><button type="button" class="mw-minibag__close" aria-label="Close">×</button></div><p class="mw-minibag__err">' + esc(res.j.description || res.j.message || 'Please try again.') + '</p><div class="mw-minibag__actions"><a class="mw-minibag__view" href="' + ROOT + 'cart">View Bag</a><a class="mw-minibag__checkout" href="' + ROOT + 'checkout">Check Out</a></div>');
          return;
        }
        var item = res.j.items ? res.j.items[0] : res.j;
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          setCount(cart.item_count);
          var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
          if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          openBag('<div class="mw-minibag__head"><p class="mw-minibag__title">' + CHECK + 'Added to Bag</p><button type="button" class="mw-minibag__close" aria-label="Close">×</button></div>' +
            '<div class="mw-minibag__item">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '<div><p class="mw-minibag__name">' + esc(item.product_title) + '</p><p class="mw-minibag__meta">' + money(item.final_price || item.price) + ' · Bag: ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' · ' + money(cart.total_price) + '</p></div></div>' +
            shipLine(cart.total_price) +
            '<div class="mw-minibag__actions"><a class="mw-minibag__view" href="' + ROOT + 'cart">View Bag</a><a class="mw-minibag__checkout" href="' + ROOT + 'checkout">Check Out</a></div>');
          if (btn) { var r = btn.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2); }
        });
      })
      .catch(function () { form.dataset.native = '1'; form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; } });
  }

  function init() {
    document.querySelectorAll('.mw-tile--gold').forEach(function (t) {
      if (t.querySelector('canvas.mw-glitter')) return;
      var c = document.createElement('canvas'); c.className = 'mw-glitter'; c.dataset.density = '0.7'; c.setAttribute('aria-hidden', 'true'); t.insertBefore(c, t.firstChild);
    });
    document.querySelectorAll('canvas.mw-glitter').forEach(glitter);
    document.querySelectorAll('canvas.mw-fx[data-el]').forEach(fx);
    document.querySelectorAll('[data-tilt]').forEach(tilt);
    document.addEventListener('submit', onSubmit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
